import { Component, OnInit } from '@angular/core';
import { Recibo } from '@app/models/recibo.model';
import { ReciboService } from '@app/services/recibo.service';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-recibo',
  templateUrl: './recibo.component.html',
  styleUrls: ['./recibo.component.scss'],
})
export class ReciboComponent implements OnInit {
  tipo: string;
  recibo: Recibo;

  constructor(
    private route: ActivatedRoute,
    private reciboService: ReciboService,
    private toastr: ToastrService
  ) {
    this.tipo = 'P';
  }

  ngOnInit() {
    this.route.params.subscribe((params: any) => {
      this.tipo = params['tipo'];
      const documento = params['documento'];

      this.reciboService.obter(this.tipo, documento).subscribe(
        (data) => {
          this.recibo = data;
          setTimeout(() => window.print(), 500);
        },
        (erro) => {
          this.toastr.error(erro.error.errors[0]);
        });
    });
  }
}
